"use client";

import { useEffect, useState } from "react";
import { subscribeToAppEvents } from "../../events";
import { ConsentAcceptedEvent } from "../../events/consent-accepted.event";
import { ConsentNotShowedEvent } from "../../events/consent-not-showed.event";
import { ConsentRejectedEvent } from "../../events/consent-rejected.event";
import type { PurposeConsents } from "../cmp/types";
import { srPurposeId } from "./constants";

export function getSrTrackingConsent({ purposeConsents }: { purposeConsents: PurposeConsents }): boolean {
  return purposeConsents?.[srPurposeId] === true;
}

export function useSrTrackingConsent() {
  const [trackingConsent, setTrackingConsent] = useState<boolean | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToAppEvents((event) => {
      if (
        event instanceof ConsentAcceptedEvent ||
        event instanceof ConsentRejectedEvent ||
        event instanceof ConsentNotShowedEvent
      ) {
        setTrackingConsent(getSrTrackingConsent(event.detail));
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return trackingConsent;
}
